var indentation_default = {
  "indentZero": "yUXS8",
  "indentOne": "i4Wl0",
  "indentTwo": "Wqed1",
  "indentThree": "P-rUg",
  "indentFour": "Ayto7",
  "indentFive": "HYWqe",
  "indentSix": "aWYbB"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
